import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const AlertContainer = styled.div`
	position: relative;
	padding: 0.5rem 1rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-top-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
	border-left-color: transparent;
	border-radius: 0.25rem;
`;
const AlertWarning = styled(AlertContainer)`
	color: #856404;
	background-color: #fff3cd;
	border-color: #ffeeba;
`;

const AdditionalDamageWarningAlert = styled(AlertWarning)`
	margin-bottom: 0;
	position: sticky;
	bottom: 0;
	text-align: center;
`;

interface AdditionalDamageWarningAlertProps {
	showAlert: boolean;
}

export const AdditionalDamageWarningAlertComponent = ({
	showAlert,
}: AdditionalDamageWarningAlertProps) =>
	showAlert ? (
		<AdditionalDamageWarningAlert>
			<FormattedMessage id="additionaldamagewarningalert.paragraph" />
		</AdditionalDamageWarningAlert>
	) : (
		<></>
	);
